import { Linear, Sine, TimelineLite } from "gsap";
import * as HLF from "html-living-framework";
import { WorldElement } from "../../GameObjects/WorldElement";
import { ICollider } from "../../Physics/ICollider";

export abstract class Obstacle extends WorldElement {
    protected _speed: number;
    protected _deflectAnim: TimelineLite | undefined;

    constructor(pSpeed: number = 0, pCollider?: ICollider) {
        super();
        this._speed = pSpeed;
        this._collider = pCollider;
        this._active = true;
    }

    public update(pDeltaTime: number): void {
        super.update(pDeltaTime);

        this.position.x += this._speed * pDeltaTime;
    }

    public destroy(pOptions: boolean | PIXI.DestroyOptions = { children: true }): void {
        if (this._deflectAnim !== undefined) { this._deflectAnim.kill(); }
        super.destroy(pOptions);
    }

    public playDeflectAnim(): void {
        this._speed = 0;
        HLF.PixiUtils.sendToFront(this);

        this._deflectAnim = new TimelineLite();
        this._deflectAnim.to(this, 1.5, {
            x: this.x + 250,
            ease: Sine.easeOut,
        }, 0);
        this._deflectAnim.to(this, 0.4, {
            y: this.y - 75,
            ease: Sine.easeOut,
        }, 0);
        this._deflectAnim.to(this, 1.1, {
            y: this.y + 800,
            ease: Sine.easeIn,
        }, 0.4);
        this._deflectAnim.to(this._image!, 2.0, {
            rotation: this.rotation + Math.PI * 4,
            ease: Linear.easeNone,
        }, 0);
        this._deflectAnim.call(() => {
            this._markedForRemoval = true;
        });
    }
}
